import type { ComponentProps } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@/lib/utils';

/**
 * Radio semantics without a radio look.
 *
 * The design asks for selectable cards (person choice in the modal, access mode
 * in the person sheet) — using the Radix primitive keeps keyboard and screen
 * reader behaviour intact while the visual treatment is entirely custom.
 */
export const RadioGroup = RadioGroupPrimitive.Root;

export function RadioCard({
  className,
  children,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      className={cn('text-left focus-visible:outline-2 focus-visible:outline-offset-2', className)}
      {...props}
    >
      {children}
    </RadioGroupPrimitive.Item>
  );
}
